import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const isNonProd = window.location.hostname.includes('icontractdev') ||
    window.location.hostname.includes('icontractqa') ||
    window.location.hostname.includes('icontractstg');

function MainLayout() {

    useEffect(() => {
        const script = document.createElement('script');
        script.src = '//js.hs-scripts.com/3277184.js';
        script.async = true;
        script.defer = true;
        script.id = 'hs-script-loader';

        document.body.appendChild(script);

        return () => {
            document.getElementById('hs-script-loader')?.remove();
        };
    }, []);


    return (
        <main>
            <Helmet>
                <meta charset="utf-8" />
                <link rel="icon" href="favicon.ico" />
                {isNonProd && (
                    <meta name="robots" content="noindex, nofollow" />
                )}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" data-rh="true" />
                <meta name="theme-color" content="#000000" />
                <meta
                    name="description"
                    content="Welcome to Airswift Digital, Your all-in-one self-service portal for a
                            seamless employment journey. Find jobs, streamline onboarding, track time, manage
                            expenses, and handle everything work-related in one place."
                    data-react-helmet="true"
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="%PUBLIC_URL%" />
                <meta property="og:title" content="Airswift Digital | Your Portal For All Hiring, Onboarding and Assignment Management" />

                <meta
                    property="og:description"
                    content="Welcome to Airswift Digital — your all-in-one portal for jobs, onboarding, time tracking, and more."
                />

                <meta
                    property="og:image"
                    content="https://www.airswift.com/hubfs/Airswift%20Digital/Airswift%20Digital%20Feature%20Image%201200x627.png"
                />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="628" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@weareairswift" />
                <meta name="twitter:url" content="%PUBLIC_URL%" />
                <meta name="twitter:title"
                        content="Airswift Digital | Your Portal For All Hiring, Onboarding and Assignment Management" />
                <meta
                    property="twitter:description"
                    content="Welcome to Airswift Digital — your all-in-one portal for jobs, onboarding, time tracking, and more."
                />
                <meta name="twitter:image"
                    content="https://www.airswift.com/hubfs/Airswift%20Digital/Airswift%20Digital%20Feature%20Image%201200x627.png" />
                <meta name="twitter:image:width" content="1200" />
                <meta name="twitter:image:height" content="628" />

                <link rel="apple-touch-icon" href="public/AirswiftLogo600x600.png" />
                <link rel="manifest" href="manifest.json" />

                {/* <!-- PWA Meta Tags --> */}
                <meta name="theme-color" content="#022D41" />
                <meta name="description" content="Airswift Digital Candidate Portal - Apply and track your applications" />

                {/* <!-- Apple Touch Icon --> */}
                <link rel="apple-touch-icon" href="/icons/apple-touch-icon.png" />

                {/* <!-- Apple Web App --> */}
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
                <meta name="apple-mobile-web-app-title" content="Airswift" />

                {/* <!-- Manifest will be auto-injected by Vite PWA plugin --> */}


                <title data-react-helmet="true">Airswift Digital | Your Portal For All Hiring, Onboarding and Assignment Management</title>
                <script type="text/javascript" src="//cdn-4.convertexperiments.com/v1/js/10046256-100417113.js?environment=production"></script>
                <script type="text/javascript">
                    {/* // this is to monkey patch specific issues with hubspot and hs-banner. */}
                    {`const hubspotRegex = /.*\.(hubspot|hs-banner)\.com.*/;
                    const oldXHROpen = window.XMLHttpRequest.prototype.open;
                    window.XMLHttpRequest.prototype.open = function (_, url) {

                    if (hubspotRegex.test(url)) {
                        const oldSetRequestHeader = this.setRequestHeader
                        const doNotAddHeaderList = ["traceparent", "Request-Context", "Request-Id"]
                        this.setRequestHeader = function (header) {
                        if (doNotAddHeaderList.includes(header)) {
                            return
                        }
                        return oldSetRequestHeader.apply(this, arguments)
                        }
                    }
                    return oldXHROpen.apply(this, arguments);
                    }`}
                </script>

                {/* <!-- Google Tag Manager --> */}
                {/* <!-- TODO: FIgure out a way in vitejs to add env variable in html--> */}
                <script>{`(function (w, d, s, l, i) {
                    w[l] = w[l] || []; w[l].push({
                        'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                    }); var f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', 'GTM-KSFJP4F5')`}</script>
                {/* End Google Tag Manager */}
            </Helmet>
            {/* <!-- Google Tag Manager (noscript) --> */}
            <noscript><iframe title='Google Tag Manager' src="https://www.googletagmanager.com/ns.html?id=GTM-KSFJP4F5" height="0" width="0"
                style={{ display: 'none', visibility: 'hidden' }}></iframe></noscript>
            {/* <!-- End Google Tag Manager (noscript) --> */}
            <Outlet />
            {/* <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/3277184.js"></script> */}
        </main>
    );
}

export default MainLayout;